import isServer from '~/scripts/isServer';

const DEBUG_PARAM = 'nd.debug';
const ENABLE_SERVER_DEBUGGING = false; // import.meta.env.DEV; // Set this to true to enable debug logging
const LOG_LEVELS = ['debug', 'info', 'warn', 'error', 'log'] as const;

type LoggerMethods = {
  [K in (typeof LOG_LEVELS)[number]]: (...args: unknown[]) => void;
};

const shouldLog = (level: (typeof LOG_LEVELS)[number]): boolean => {
  const hasDebugParam = isServer()
    ? ENABLE_SERVER_DEBUGGING
    : new URLSearchParams(window.location.search)?.has(DEBUG_PARAM);

  if (level === 'debug') {
    return hasDebugParam;
  }

  return true;
};

const createLogger = (): LoggerMethods => {
  const logger: Partial<LoggerMethods> = {};

  LOG_LEVELS.forEach((level) => {
    logger[level] = (...args: unknown[]) => {
      if (!shouldLog(level)) {
        return;
      }

      // Preserve the original stack trace by using Function.prototype.bind
      // eslint-disable-next-line no-console
      const originalConsoleMethod = console[level].bind(console);
      originalConsoleMethod(...args);
    };
  });

  return logger as LoggerMethods;
};

export const logger = createLogger();
